import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Component, OnInit, ViewChildren, AfterViewInit, OnDestroy, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { CdkDetailRowDirective } from 'src/app/shared/directive/cdk-detail-row.directive';
import { MatDialog } from '@angular/material/dialog';
import { AddDocumentGroupComponent } from './add-document-group/add-document-group.component';
import { DialogSyncDocumentGroupComponent } from './dialog-sync-document-group/dialog-sync-document-group.component'
import { MatTableDataSource } from '@angular/material/table';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ServiceTypeService } from 'src/app/core/services/service-type.service';
import { from, Subscription } from 'rxjs';
import { CommonService } from 'src/app/core/services/common.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResponsiveService } from '../../../../../../core/services/responsive.service';
import { UpdateDocumentTypeComponent } from '../../document-type/update-document-type/update-document-type.component';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { isTemplateExpression } from 'typescript';
import { PickConfigureDisplayedComponent } from './pick-configure-displayed/pick-configure-displayed.component';
import { ConfigDocumentGroupComponent } from './config-document-group/config-document-group.component';
import { ContractService } from 'src/app/core/services/contract.service';
import { ConfirmOnEkycSupportComponent } from '../confirm-on-ekyc-support/confirm-on-ekyc-support.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-document-group-manage',
  templateUrl: './document-group-manage.component.html',
  styleUrls: ['./document-group-manage.component.scss']
})
export class DocumentGroupManageComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSource = new MatTableDataSource();
  totalServiceType: number;
  isReadySignEkyc: boolean;
  isReadySignEkycAdvanced: boolean;
  widthHeadCofig = '';
  quantityEkycInfo = {
    ekycQuantity: 0,
    advanceEkycQuantity: 0,
    isBoughtEkyc: true,
    isBoughtEkycAdvanced: true
  };
  isDisableEKYC = false;

  displayedFirstColumns: string[] = [];
  firstColumnDefinitions = [
    { def: 'firstId', showMobile: true },
    { def: 'firstName', showMobile: true },
    { def: 'firstCode', showMobile: true },
    { def: 'firstNote', showMobile: false },
    { def: 'firstValidate', showMobile: false },
    { def: 'firstAction', showMobile: true },
  ];

  // displayedColumns: string[] = ['id', 'name', 'note', 'action'];
  displayedColumns: string[] = [];
  columnDefinitions = [
    { def: 'id', showMobile: true, show: true },
    { def: 'name', showMobile: true, show: true },
    { def: 'code', showMobile: true, show: true },
    { def: 'note', showMobile: false, show: true },
    // { def: "allowEKYC", showMobile: false, show: false },
    // { def: "allowEkycAdvanced", showMobile: false, show: false },
    // { def: "allowOtp", showMobile: false, show: true },
    // { def: "allowImage", showMobile: false, show: true },
    // { def: "checkCertNumber", showMobile: false, show: true },
    // { def: "checkName", showMobile: false, show: true },
    // { def: "checkOtp", showMobile: false, show: true },
    // { def: "supportEkyc", showMobile: false, show: false },
    // { def: "allowEKYC", showMobile: false, show: false },
    // { def: "allowEkycAdvanced", showMobile: false, show: false },
    { def: 'action', showMobile: true, show: true },
  ];

  childDataSourceList: any;
  displayedChildColumns: any;
  sortColumn = 'name';
  isTableLoading = false;
  documents = new Document();
  paginate: {
    currentPage: number;
    pageSize: number;
    totalRow: number;
    totalPage: number;
    totalPageArray: any;
    no: any;
  };
  tplModal: NzModalRef;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('contentEmptyTable', { static: false }) contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table

  formChangesSubscription: Subscription;

  checkNote: any;

  @BlockUI() blockUI: NgBlockUI;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isNotAttestedUser: boolean = false;
  isBuyTwoService: boolean = false
  isDefaultAdmin: boolean = false

  constructor(
    private dialog: MatDialog,
    private serviceTypeService: ServiceTypeService,
    public commonService: CommonService,
    private message: Message,
    private toastr: ToastrService,
    private responsiveService: ResponsiveService,
    private modalService: NzModalService,
    private contractService: ContractService,
    private router: Router,
  ) {
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.isBuyTwoService = this.commonService.checkBuyTwoServiceWithoutHauntAndAdmin()
    this.isDefaultAdmin = this.commonService.checkDefaultAdmin()
  }

  ngOnInit() {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: [],
    };

    this.documents = {
      name: '',
      note: ''
    };

    this.onFilterData();
    this.checkConfigureDisplayed();
    this.getQuantityEkyc();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    // merge(this.sort.sortChange, page)
    //   .pipe(
    //     /* tap(() => this.loadData()) */
    //     tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
    //   )
    //   .subscribe();
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
          this.getDisplayedFirstColumns();
        }
      }
    );
  }
  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }
  getDisplayedFirstColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedFirstColumns = this.firstColumnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedFirstColumns = this.firstColumnDefinitions.map(cd => cd.def);
    }
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.show)
        .map(cd => cd.def);
    }
  }

  onOpenAddOrEditDialog(serviceType: any = null) {
    const serviceTypeCopy = Object.assign({}, serviceType);
    const dialogRef = this.dialog.open(AddDocumentGroupComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '50%' : '32%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: { serviceType: serviceTypeCopy }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onFilterDataAfterClose();
      // if (dialogRef.componentInstance.success) {
      // console.log('dong dialog add thanh cong');
      //   this.onFilterDataAfterClose();
      // }
    });
  }

  onOpenPickTypeConfigureDisplayed() {
    const dialogRef = this.dialog.open(PickConfigureDisplayedComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '85%' : '60%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '85vw' : '60vw',
      panelClass: 'scontract-overlay-dialog',
      data: {
        checkCertNumber: this.columnDefinitions[6].show,
        checkName: this.columnDefinitions[7].show,
        checkOtp: this.columnDefinitions[8].show,
        supportEkyc: this.columnDefinitions[9].show,
        isShowEkyc: this.isReadySignEkyc || this.isReadySignEkycAdvanced,
        allowEKYC: this.columnDefinitions[10].show,
        allowEkycAdvanced: this.columnDefinitions[11].show,
        isReadySignEkyc: this.isReadySignEkyc,
        isReadySignEkycAdvanced: this.isReadySignEkycAdvanced
      }
    });
    dialogRef.afterClosed().subscribe(rs => {
      this.onColumnDefinitionsChange(rs);
      // this.columnDefinitions.forEach(element => {
      //   if(rs.data.includes(element.def)) {
      //     element.show = false;
      //   } else {
      //     element.show = true;
      //   }
      // })
      // this.widthHeadCofig = `${(rs.count + 2) * 90}px`;
      // this.getDisplayedColumns()
    });
  }

  onColumnDefinitionsChange(configureDisplayed: any) {
    this.columnDefinitions.forEach(element => {
      if (configureDisplayed.data.includes(element.def)) {
        element.show = false;
      } else {
        element.show = true;
      }
    });
    this.widthHeadCofig = `${(configureDisplayed.count + 2) * 90}px`;
    this.getDisplayedColumns();
  }

  checkConfigureDisplayed() {
    if (localStorage.getItem('configureDisplayed')) {
      const configureDisplayed = JSON.parse(localStorage.getItem('configureDisplayed'));
      this.onColumnDefinitionsChange(configureDisplayed);
    }
  }

  onOpenConfigDocumentGroupDialog(serviceType: any = null) {
    const dialogRef = this.dialog.open(ConfigDocumentGroupComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '80%' : '50%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: {
        serviceType,
        isReadySignEkyc: this.isReadySignEkyc,
        isReadySignEkycAdvanced: this.isReadySignEkycAdvanced,
        quantityEkycInfo: this.quantityEkycInfo
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.onFilterData();
    });
  }

  onFilterDataAfterClose() {
    if (this.paginate.totalRow % this.paginate.pageSize === 1) {
      if (this.paginate.currentPage - 1 < 0) {
        this.paginate.currentPage = 0;
      } else {
        this.paginate.currentPage = this.paginate.currentPage - 1;
      }
    }
    this.onFilterData();
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize
    };

    this.onFilterData();
  }

  onFilterData() {
    this.isTableLoading = true;
    this.dataSource.data = [];
    this.serviceTypeService.filterServiceTypes(
      {
        ...this.documents,
        ...this.paginate,
        page: this.paginate.currentPage,
      }
    ).subscribe(result => {
      this.isTableLoading = false;
      console.log(result);
      const { data } = result;

      this.dataSource.data = data.data.dataRow;

      if (data.data.dataRow) {
        this.checkNote = data.data.dataRow.filter((data: any) => data && data.type == 2);
      }
      this.isReadySignEkyc = data.allowEkyc;
      this.isReadySignEkycAdvanced = data.allowAdvanceEkyc;
      this.totalServiceType = data.totalRow;
      // console.log(data.totalRow)
      // console.log(data)
      this.paginate = {
        ...this.paginate,
        currentPage: data.data.currentPage,
        pageSize: data.data.pageSize,
        totalRow: data.data.totalRow,
        totalPage: Math.ceil(data.data.totalRow / data.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(data.data.totalRow / data.data.pageSize), 1),
        no: this.commonService.counter(data.data.pageSize, data.data.currentPage * data.data.pageSize + 1)
      };


    }, () => this.isTableLoading = false);

  }

  onClickBtnFilter() {
    this.onFilterData();
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }

  viewDetail(id: any) {

  }

  onUpdate(element: any) {

  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row) {

  }

  sortChildData($event: Sort, id: any) {

  }


  onClickDeleteButton(serviceType: any) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_service_type'), serviceType.name)
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.serviceTypeService.deleteCustomer(serviceType.id).subscribe(
          (res) => {
            if (res.success) {
              this.toastr.success(this.message.getMessage('messages.delete_success'));
              if (this.paginate.totalRow % this.paginate.pageSize === 1) {
                if (this.paginate.currentPage - 1 < 0) {
                  this.paginate.currentPage = 0;
                } else {
                  this.paginate.currentPage = this.paginate.currentPage - 1;
                }
              }
              this.onFilterData();
            } else {
              this.toastr.error(res.message);
            }
          }
        );
      }
      this.focusInput.first.nativeElement.focus();
    });
  }

  onAllowCheckSign(document: any, isAllowCheck: boolean, type: string) {
    let dataDialog;
    let isShowDialogConfirmChooseEkyc = false;
    let dialogRef: any;
    if (type === 'allowOtp') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_sign_otp_type' : 'messages.confirm_on_sign_otp_type'), document.name);
    }
    if (type === 'allowImage') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_sign_image_type' : 'messages.confirm_on_sign_image_type'), document.name);
    }
    if (type === 'checkCertNumber') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_check_cts_type' : 'messages.confirm_on_check_cts_type'), document.name);
    }
    if (type === 'checkName') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_check_name_type' : 'messages.confirm_on_check_name_type'), document.name);
    }
    if (type === 'checkOtp') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_check_otp_type' : 'messages.confirm_on_check_otp_type'), document.name);
    }

    // EKYC & EKYC advanced
    if (type === 'allowEkyc') {
      dataDialog = this.commonService.format(this.message.getMessage(
        document.allowAdvancedEkyc ? 'messages.confirm_on_sign_ekyc_and_of_ekyc_advanced' :
          (isAllowCheck ? 'messages.confirm_off_sign_ekyc' : 'messages.confirm_on_sign_ekyc')), document.name);
    }

    if (type === 'allowAdvancedEkyc') {
      dataDialog = this.commonService.format(this.message.getMessage(
        document.allowEkyc ? 'messages.confirm_on_sign_ekyc_advanced_and_of_ekyc' :
          (isAllowCheck ? 'messages.confirm_off_sign_ekyc_advanced' : 'messages.confirm_on_sign_ekyc_advanced')), document.name);
    }

    // ekyc support
    if (type === 'checkEkycSupport') {
      // dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
      //   ? 'messages.confirm_off_ekyc_support' : 'messages.confirm_on_ekyc_support'), document.name);
      let message = '';
      if (isAllowCheck) {
        message = 'messages.confirm_off_ekyc_support';
      } else {
        if (this.quantityEkycInfo.isBoughtEkyc && this.quantityEkycInfo.isBoughtEkycAdvanced) {
          message = 'messages.confirm_on_choose_ekyc_support';
          isShowDialogConfirmChooseEkyc = true;
        } else if (this.quantityEkycInfo.isBoughtEkyc || this.quantityEkycInfo.isBoughtEkycAdvanced) {
          message = 'messages.confirm_on_ekyc_support';
        }
      }
      dataDialog = this.commonService.format(this.message.getMessage(message), document.name);
    }

    if (isShowDialogConfirmChooseEkyc) {
      dialogRef = this.dialog.open(ConfirmOnEkycSupportComponent, {
        width: '400px',
        data: { message: dataDialog, quantityEkycInfo: this.quantityEkycInfo }
      });
    } else {
      dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        data: dataDialog
      });
    }

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        if (type === 'allowOtp') {
          document.allowOtp = !document.allowOtp;
        }
        if (type === 'allowImage') {
          document.allowImage = !document.allowImage;
        }
        if (type === 'checkCertNumber') {
          document.checkCertNumber = !document.checkCertNumber;
        }
        if (type === 'checkName') {
          document.checkName = !document.checkName;
        }
        if (type === 'checkOtp') {
          document.checkOtp = !document.checkOtp;
        }

        // EKYC && EKYC Advanced
        if (type === 'allowEkyc') {
          document.allowEkyc = !document.allowEkyc;
          if (document.allowAdvancedEkyc) {
            document.allowAdvancedEkyc = false;
          }
        }
        if (type === 'allowAdvancedEkyc') {
          document.allowAdvancedEkyc = !document.allowAdvancedEkyc;
          if (document.allowEkyc) {
            document.allowEkyc = false;
          }
        }

        if (type === 'checkEkycSupport') {
          // document.checkEkycSupport = !document.checkEkycSupport;
          if (isShowDialogConfirmChooseEkyc) {
            document.ekycSupportConfig = rs;
          } else {
            if (isAllowCheck) {
              document.ekycSupportConfig = 0;
            } else {
              if (this.quantityEkycInfo.isBoughtEkyc) { document.ekycSupportConfig = 1; }
              if (this.quantityEkycInfo.isBoughtEkycAdvanced) { document.ekycSupportConfig = 2; }
            }
          }
        }
        this.serviceTypeService.updateServiceTypes(document, (err) => {
        }).subscribe((res) => {
          if (res.success) {
            this.toastr.success(this.message.getMessage('messages.update_success'));
            if (this.paginate.totalRow % this.paginate.pageSize === 1) {
              if (this.paginate.currentPage - 1 < 0) {
                this.paginate.currentPage = 0;
              } else {
                this.paginate.currentPage = this.paginate.currentPage - 1;
              }
            }
            this.onFilterData();
          } else {
            this.toastr.error(res.message);
          }
        });
      }
      this.focusInput.first.nativeElement.focus();
    });
  }

  createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>): void {
    this.tplModal = this.modalService.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: true,
      nzClosable: true,
      nzOnOk: () => console.log('Click ok')
    });
  }

  destroyTplModal(): void {
    setTimeout(() => {
      this.tplModal.destroy();
    }, 300);
  }
  // EKYC
  getQuantityEkyc() {
    this.contractService.getDataCountNumberDocumentOfEnterpriseByService().subscribe(res => {
      if (Object.keys(res.data).length !== 0 && res.data.constructor === Object) {
        // lấy số lượng ký ekyc và ekyc nâng cao: số lượng >=0 -> đã mua, số lượng undefined -> chưa mua
        if (res.data.ekycQuantity !== undefined) {
          this.quantityEkycInfo.ekycQuantity = res.data.ekycQuantity;
        } else {
          this.quantityEkycInfo.isBoughtEkyc = false;
        }

        if (res.data.advanceEkycQuantity !== undefined) {
          this.quantityEkycInfo.advanceEkycQuantity = res.data.advanceEkycQuantity;
        } else {
          this.quantityEkycInfo.isBoughtEkycAdvanced = false;
        }
      }
      // console.log(this.quantityEkycInfo)
      this.getIsDisabledEkyc(this.quantityEkycInfo);
    });
  }

  getIsDisabledEkyc(quantityEkycInfo): void {
    // console.log(quantityEkycInfo)
    this.isDisableEKYC = (!quantityEkycInfo.isBoughtEkyc && !quantityEkycInfo.isBoughtEkycAdvanced);
    // (!quantityEkycInfo.isBoughtEkyc && !quantityEkycInfo.isBoughtEkycAdvanced)
    // || (quantityEkycInfo.isBoughtEkyc && !quantityEkycInfo.isBoughtEkycAdvanced && !quantityEkycInfo.ekycQuantity)
    // || (!quantityEkycInfo.isBoughtEkyc && quantityEkycInfo.isBoughtEkycAdvanced && !quantityEkycInfo.advanceEkycQuantity)
    // || (quantityEkycInfo.isBoughtEkyc && quantityEkycInfo.isBoughtEkycAdvanced && !quantityEkycInfo.ekycQuantity && !quantityEkycInfo.advanceEkycQuantity)
  }

  createOrEditGroupDocument(serviceType: any) {
    this.router.navigate(['/home-enterprise/add-document-group-v2'], {
      queryParams: { serviceTypeId: serviceType.id }
    });
  }

  openDialogSync() {
    const dialogRef = this.dialog.open(DialogSyncDocumentGroupComponent, {
      width: '95%',
      maxWidth: '95vw',
      panelClass: 'synchronized-overlay-dialog'
    });
    dialogRef.afterClosed().subscribe((rs) => {
      if (rs) this.onFilterData();
    });
  }
}

export class Document {
  name: string;
  note: string;
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: any;
  no: any;
}
